const CatalogsView = () =>
  import(
    /* webpackChunkName: "catalogs" */ '@/modules/catalogs/views/CatalogsView'
  )

export default [
  {
    path: '/catalogos',
    name: 'catalogs',
    meta: {
      title: 'Catálogos',
      requiresAuth: true,
      requiresConsultingRoomAdmin: true,
    },
    component: CatalogsView,
  },
]
